import { render, staticRenderFns } from "./AlertComment.vue?vue&type=template&id=4465179a&scoped=true"
import script from "./AlertComment.vue?vue&type=script&lang=js"
export * from "./AlertComment.vue?vue&type=script&lang=js"
import style0 from "./AlertComment.vue?vue&type=style&index=0&id=4465179a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4465179a",
  null
  
)

export default component.exports